import { LiquidacionesAPIConstant } from "../administracion/liquidaciones/liquidaciones.constant";
import { EscrutarApiConstant } from "../escrutinio/escrutar/escrutar-api.constant";

// Tipos literales para los métodos HTTP válidos
export enum HttpMethodEnum {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    PATCH = 'PATCH',
    OPTIONS = 'OPTIONS',
    HEAD = 'HEAD',
}

// Tipos para las rutas excluidas
export type ExcludedRoute = {
    url: string;
    method: HttpMethodEnum;
}

/** 
 * Definir las rutas a excluir:
 * - No hay necesidad de establecer los parámetros en la lista
 * - Los campos que tengan un id deben tener el formato :id
 * - Ejemplo de manejo de PATCH con id y parámetros: { url: 'https://api.example.com/orders/:id', method: 'PATCH' },
 */
const EXCLUDED_URL_PATTERNS_RAW: ExcludedRoute[] = [
    { url: `${LiquidacionesAPIConstant.URL_GET_LIQUIDACION_INGRESO}/notify`, method: HttpMethodEnum.GET },
    { url: `${EscrutarApiConstant.BASE_URL_ESCRUTINIO}${EscrutarApiConstant.ESCRUTAR}filter/confirmation`, method: HttpMethodEnum.GET },
    { url: `${EscrutarApiConstant.BASE_URL_ESCRUTINIO}${EscrutarApiConstant.ESCRUTAR}filter/scrutinitys`, method: HttpMethodEnum.GET },
];

/**
 * Convierte las rutas en expresiones regulares.
 * - Reemplaza ":id" por "\d+" (cualquier número).
 * - Ignora los parámetros de consulta (`query params`).
 */
const convertToRegExp = (route: ExcludedRoute) => ({
    method: route.method,
    pattern: new RegExp(`${route.url.replace(/:[a-zA-Z]+/g, '\\d+')}`)
});

// Genera las expresiones regulares dinámicamente
export const EXCLUDED_URL_PATTERNS = EXCLUDED_URL_PATTERNS_RAW.map(convertToRegExp);
